import { render, staticRenderFns } from "./TableMobile.vue?vue&type=template&id=58374b79&"
import script from "./TableMobile.vue?vue&type=script&lang=js&"
export * from "./TableMobile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports